export default __webpack_public_path__ + "static/media/caloTokenStr.88cbe3dc.png";